'use client';

import styled from 'styled-components';

export const NotFoundBgWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f9f7f1;
`;

export const NotFoundBgLeft = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  pointer-events: none;
  z-index: 0;
`;

export const NotFoundBgRight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  top: 36px;
  pointer-events: none;
  z-index: 0;
`;
